import Vue from "vue";

const snackMessage = msg => {
  return Vue.prototype
    .$snackOpen({
      contents: msg,
      btnDisplayYN: false
    })
    .then(() => {});
};

export default snackMessage;
